import MaskedNumberInput, { MaskedNumberInputProps } from 'components/masked-number-input';

import { RUBLE_SIGN } from 'lib/constants';
import { toReadablePrice } from 'lib/utils';

type PriceInputProps = MaskedNumberInputProps;

const PriceSqMInput: React.FC<PriceInputProps> = (props) => {
  return (
    <MaskedNumberInput
      min={1}
      decimal
      sign={RUBLE_SIGN}
      max={1_000_000_000_000}
      format={toReadablePrice}
      {...props}
    />
  );
};

export default PriceSqMInput;
